const mobileMenuLinks = document.querySelectorAll('.main-nav-item-link-with-button.-js-accordion__trigger a');

if (mobileMenuLinks) {
    [...mobileMenuLinks].forEach(linkEl => {
        linkEl.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });
}
